import type { TRequestsHandler } from '~/utils/requestsProcessor/types';

export class AuthImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** POST /auth/signin */
  public postAuthSignIn(body: { message: string; signature: string; pendingReferrerId?: number }) {
    return this.makeRequest<string>(`auth/signin`, { method: 'POST', body });
  }

  /** POST /auth/refresh */
  public postAuthRefresh() {
    return this.makeRequest<string>(`auth/refresh`, { method: 'POST' });
  }

  /** GET /auth/check */
  public getAuthCheck() {
    return this.makeRequest<{ userId: number; role: string }>(`auth/check`, { method: 'GET' });
  }

  /** GET /auth/nonce */
  public getAuthNonce() {
    return this.makeRequest<{ nonce: string }>(`auth/nonce`, { method: 'GET' });
  }
}
